/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CustomMetadataEntryStatsFilterElementDto = {
    id: string;
    type: CustomMetadataEntryStatsFilterElementDto.type;
};

export namespace CustomMetadataEntryStatsFilterElementDto {

    export enum type {
        LABEL = 'LABEL',
        USER = 'USER',
        STRING = 'STRING',
        TEAM = 'TEAM',
    }


}
